import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'

class FinalRenewalToken extends React.PureComponent {

  static propTypes = {
    cancellation: PropTypes.object,
    service: PropTypes.object,
    subscription: PropTypes.object
  }

  render() {
    const cycle = this._getCycle()
    const instructions = this._getInstructions(cycle)
    const items = this._getItems(cycle)
    return (
      <div className="subscriptions-price-token">
        { instructions }
        <table className="ui compact celled unstackable table">
          <thead>
            <tr>
              <th>Item</th>
              <th className="collapsing">Price</th>
            </tr>
          </thead>
          <tbody>
            { items.map((item, index) => (
              <tr key={`item_${index}`}>
                <td>{ item.text }</td>
                <td className="right aligned">{ numeral(item.price).format('0.00') }</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <td className="right aligned">{ numeral(items.reduce((total, item) => {
                return Number(total) + Number(item.price)
              }, 0.00)).format('0.00') }</td>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  _getCycle() {
    const { cancellation, subscription } = this.props
    const { canceled_on } = cancellation
    const { current_period, current_cycle } = subscription
    const { start_date, end_date } = current_cycle
    const last = moment(canceled_on).startOf('day')
    const start = moment(start_date).startOf('day')
    const end = moment(end_date).startOf('day')
    const charge = last
    const length = parseInt(end.diff(start, 'day')) + 1
    const remaining = parseInt(last.diff(start, 'day')) + 1
    const today = moment().startOf('day')
    return {
      last: last.format('MM/DD/YY'),
      charge: charge.format('MM/DD/YY'),
      start: start.format('MM/DD/YY'),
      end: end.format('MM/DD/YY'),
      prorate: remaining / length,
      delay: charge.diff(today, 'day'),
      length,
      remaining
    }
  }

  _getInstructions(cycle) {
    const when = cycle.delay > 0 ? `on ${cycle.charge}` : ''
    const type = cycle.prorate < 1 ? 'prorated' : 'full'
    return `
      The following renewal will be generated ${when} to cover the
      the ${type} billing cycle (${cycle.start} - ${cycle.last})
    `
  }

  _getItems(cycle) {
    const { service, subscription } = this.props
    const { current_period } = subscription
    const { addons, plan } = current_period
    const proration = (price) => {
      return cycle.prorate < 1 ? `(${numeral(price).format('0.00')}, prorated for ${cycle.remaining}/${cycle.length} days)` : ''
    }
    const items = []
    const billing_cycle = `${cycle.start} - ${cycle.last}`
    items.push({
      text: <>{ service.title }: { plan.title }: { billing_cycle } { proration(current_period.price) }</>,
      price: cycle.prorate * Number(current_period.price)
    })
    addons.map(addon => {
      items.push({
        text: <>{ service.title }: { addon.title }: { billing_cycle }{ proration(addon.price) }</>,
        price: cycle.prorate * Number(addon.price)
      })
    })
    return items
  }

}

export default FinalRenewalToken
